import classNames from 'classnames';
import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';
import { SearchBarOrderSearch } from './SearchBarOrderSearch';
import {
  useGetMostRecentQuery,
  useGetPinnedQuery,
  useSetMostRecentMutation,
  useSetPinnedMutation,
} from 'API/order/PinnedAndRecentAPI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/pro-light-svg-icons';
import { faGear as faGearSolid } from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'ui-toolkit/components/Button/Button';
import { HeaderText3TW } from 'tailwindComponents/HeaderTextTW/HeaderTextTW';
import { SearchBarSettingsContainer } from './SearchBarSettingsContainer';
import { SearchBarOrderGroup } from './SearchBarOrderGroup';

export interface ISearchBarDialogProps {}

const maxWidth = 'max-w-7xl';

const panelcss = `w-full ${maxWidth} transform overflow-hidden rounded-xl bg-white p-2 text-left align-middle shadow-xl transition-all`;

export const SearchBarDialog: React.FC<ISearchBarDialogProps> = () => {
  const [currentSearch, setCurrentSearch] = useState<string>('');
  const { data: pinned = [] } = useGetPinnedQuery();
  const { data: mostRecent = [] } = useGetMostRecentQuery();
  const [setPinned] = useSetPinnedMutation();
  const [setMostRecent] = useSetMostRecentMutation();
  const [showSettings, setShowSettings] = useState<boolean>(false);

  return (
    <Dialog.Panel className={`w-full ${maxWidth}`}>
      <div className={'flex flex-col gap-1'}>
        <div className={classNames(panelcss, 'flex flex-row justify-between')}>
          <input
            type={'text'}
            className={classNames(
              'xs:text-xs xs:leading-6 block h-10 basis-11/12 rounded-md border-0 p-1.5 ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-inset',
              'text-gray-900 placeholder:text-text-content-placeholder focus:ring-foundation-primary',
              showSettings ? 'hidden' : ''
            )}
            value={currentSearch}
            placeholder={'Search for an Order by file number...'}
            onChange={(event) => setCurrentSearch(event.target.value)}
            data-test-id={'Jump-Input'}
          />
          {showSettings && <HeaderText3TW>Jump Box Settings</HeaderText3TW>}
          <Button
            intent={'ghost'}
            isInline
            onClick={() => setShowSettings(!showSettings)}
            data-test-id={'Jump-Settings'}
          >
            <FontAwesomeIcon icon={showSettings ? faGearSolid : faGear} size={'2x'} />
          </Button>
        </div>
        {showSettings && (
          <div className={panelcss}>
            <SearchBarSettingsContainer />
          </div>
        )}
        {!showSettings && (
          <div className={panelcss}>
            <SearchBarOrderGroup
              groupName={'Pinned Orders'}
              currentSearch={currentSearch}
              nothingMessage={`You haven't pinned any orders yet!`}
              emptyFilterMessage={`None of your pinned orders match that filter`}
              fileNumberList={pinned}
              setFileNumberList={setPinned}
            />
          </div>
        )}
        {!showSettings && (
          <div className={panelcss}>
            <SearchBarOrderGroup
              groupName={'Recent Orders'}
              currentSearch={currentSearch}
              nothingMessage={`Somehow, you have avoided looking at any orders!`}
              emptyFilterMessage={`None of your recent orders match that filter`}
              fileNumberList={mostRecent}
              setFileNumberList={setMostRecent}
            />
          </div>
        )}
        {!showSettings && !!currentSearch && (
          <div className={panelcss}>
            <SearchBarOrderSearch
              title={'Search Results'}
              currentSearch={[currentSearch]}
              emptyMessage={'Unable to find any orders with that file number'}
            />
          </div>
        )}
      </div>
    </Dialog.Panel>
  );
};
